import { Fragment } from 'react';

import { Body } from 'components/Text/Body';
import { BodySmall } from 'components/Text/BodySmall';
import { H2 } from 'components/Text/H2';
import { H3 } from 'components/Text/H3';
import { CmsApiAccordionBlockData } from 'modules/cms/api/types/blocks/CmsApiAccordionBlock';

type Props = {
  data: CmsApiAccordionBlockData;
};

export function CmsAmpAccordionBlock({
  data: { sections, headline, subtitle },
}: Props) {
  return (
    <>
      {headline && <H2>{headline}</H2>}
      {subtitle && (
        <Body
          dangerouslySetInnerHTML={{
            __html: subtitle,
          }}
        />
      )}

      {sections.map((section, index) => (
        // TODO: Fix this the next time the file is edited.
        // eslint-disable-next-line react/no-array-index-key
        <Fragment key={index}>
          <H3>{section.title}</H3>
          <BodySmall
            dangerouslySetInnerHTML={{
              __html: section.content,
            }}
          />
        </Fragment>
      ))}
    </>
  );
}
